import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { BetBuilderPickResponse } from "@api-types/bet-booster/BetBuilderPickResponse";
import { GenericResponse } from "@api-types/common";
import { getApplicationHeaders, httpClient } from "@utils";

export class BetBoosterApiService {
	static get baseUrl() {
		return `${WEBPACK_BET_BOOSTER_API_ADDRESS}/betbooster`;
	}
	static getRequestHeaders() {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static async getBettingTips(params?: {
		eventId?: string;
		tournamentId?: string;
	}): Promise<GenericResponse<BettingTips[]>> {
		let url = `${this.baseUrl}/tips`;
		const queryParams = new URLSearchParams();

		if (params?.eventId) {
			queryParams.append("eventId", params.eventId);
		}
		if (params?.tournamentId) {
			queryParams.append("tournamentId", params.tournamentId);
		}

		const queryString = queryParams.toString();

		if (queryString) {
			url += `?${queryString}`;
		}

		return httpClient.get(url, this.getRequestHeaders(), {
			responseType: "json",
		});
	}
}
